import { render, staticRenderFns } from "./WorkIconArchived.vue?vue&type=template&id=3be2b9bb"
import script from "./WorkIconArchived.vue?vue&type=script&lang=js"
export * from "./WorkIconArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports